import React, { useState } from "react";
import Input from "../../common/Input";
import Button from "../../common/Button";

const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (key: string, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const res = await fetch(`api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Failed to send");

      setSuccess(true);
      setForm({ name: "", email: "", message: "" });
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="md:px-20 pt-10 md:py-8 h-fit w-full ">
      <span className="font-bold text-sm md:text-xl uppercase">
        {"> "}Contact Form
      </span>

      <div className="flex flex-col md:flex-row mt-5 md:mt-10">
        <div className="w-full flex flex-col mr-10 justify-between">
          <Input
            label="Name"
            isRequired
            value={form.name}
            onChange={(e: any) => handleChange("name", e.target.value)}
          />
          <Input
            label="Email"
            isRequired
            value={form.email}
            onChange={(e: any) => handleChange("email", e.target.value)}
          />
        </div>

        <div className="flex w-full">
          <Input
            label="Message"
            isRequired
            textArea
            value={form.message}
            onChange={(e: any) => handleChange("message", e.target.value)}
          />
        </div>
      </div>

      <div className="w-full flex justify-end items-end pt-6 gap-4">
        {success && (
          <span className="text-green-500 text-sm">
            ✓ Thank you for your message! I will get back to you soon.
          </span>
        )}
        {error && <span className="text-red-500 text-sm">{error}</span>}
        <Button
          label={loading ? "Sending..." : "Send"}
          onClick={handleSubmit}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default ContactForm;
